"use client";

import React from "react";
import { useAuth } from "../../../contexts/AuthContext";

interface AdminColegioLayoutProps {
  children: React.ReactNode;
}

const AdminColegioLayout: React.FC<AdminColegioLayoutProps> = ({
  children,
}) => {
  const { user, logout } = useAuth();

  const isActive = (path: string) => {
    return window.location.pathname === path;
  };

  const navItems = [
    {
      path: "/admin-colegio/dashboard",
      label: "Dashboard",
    },
    {
      path: "/admin-colegio/administrar",
      label: "Administrar",
    },
    {
      path: "/admin-colegio/calendario",
      label: "Calendario",
    },
    {
      path: "/admin-colegio/reportes",
      label: "Reportes",
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 to-pink-50">
      {/* HEADER */}
      <header className="bg-white shadow border-b">
        <div className="max-w-7xl mx-auto px-6 h-20 flex justify-between items-center">
          <div>
            <h1 className="text-2xl font-bold text-purple-700">
              Fracto Admin Colegio
            </h1>
            <p className="text-xs text-gray-500">Panel de Control</p>
          </div>

          <div className="flex items-center gap-4">
            <div className="text-right">
              <p className="text-sm font-semibold">
                {user?.nombres} {user?.apellidos}
              </p>
              <p className="text-xs text-gray-500">{user?.email}</p>
            </div>

            <button
              onClick={logout}
              className="text-sm text-red-600 hover:underline"
            >
              Cerrar sesión
            </button>
          </div>
        </div>
      </header>

      <nav className="bg-white border-b shadow-sm">
        <div className="max-w-7xl mx-auto px-6 flex gap-6">
          {navItems.map((item) => {
            const active = isActive(item.path);

            return (
              <a
                key={item.path}
                href={item.path}
                className={`py-4 font-medium transition ${
                  active
                    ? "text-purple-600 border-b-2 border-purple-600"
                    : "text-gray-600 hover:text-purple-600"
                }`}
              >
                {item.label}
              </a>
            );
          })}
        </div>
      </nav>

      <main className="max-w-7xl mx-auto px-6 py-8">{children}</main>
    </div>
  );
};

export default AdminColegioLayout;
